

































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  UnitDeviceData, emptyData, UnitDevicePointData, emptyPoint, getInfo, putData, postData
} from '@/api/heritageUnit/unitDevice'
import { validateIntKey, showVaildMsg } from '@/configs/validate'
import { DDLItem } from '@/api/common/select'
import { enFirstType } from '@/configs/enums'
import Element from 'element-ui'
import { PopUnitData } from '@/api/heritageUnit/heritageUnit'
import DevicePointList from '@/components/unitDevice/form/point/list.vue'
import PageForm from '@/components/pageLayout/form.vue'
import UnitSearchForm from '@/components/heritageUnit/search/index.vue'

import { namespace } from 'vuex-class'
const DataSourceModule = namespace('dataSource')

const getFormRules = (id: number, form: { [key: string]: string }) => {
  return {
    UnitName: [{ required: true, message: '请选择文保单位' }],
    DeviceAliase: [
      { required: true, message: '请输入设备名称', trigger: 'blur' }
    ],
    DeviceCategoryId: [
      {
        required: true,
        validator: validateIntKey('请选设备类型'),
        trigger: 'change'
      }
    ],
    DeviceNumber: [
      { required: true, message: '请输入设备编码号', trigger: 'blur' }
    ],
    DeviceSerialId: [
      { required: true, message: '请输入设备序列号', trigger: 'blur' }
    ],
    DeviceBrand: [
      {
        required: true,
        validator: validateIntKey('请选设备品牌'),
        trigger: 'change'
      }
    ],
    DeviceStatus: [
      {
        required: true,
        validator: validateIntKey('请选设备状态'),
        trigger: 'change'
      }
    ]
  }
}

@Component({
  components: {
    PageForm, UnitSearchForm, DevicePointList
  }
})
export default class UnitDeviceForm extends Vue {
  public collapseNames: string[] = ['base', 'points']

  public form: UnitDeviceData = Object.assign({}, emptyData)
  public loading = false

  public categoryList: DDLItem[] = []
  public brandList: DDLItem[] = []
  public driverList: DDLItem[] = []
  public statusList: DDLItem[] = []
  public rules = getFormRules(0, this.form)

  // dynamic component
  public $refs!: {
    formCtrl: PageForm
    pointCtrl: DevicePointList
    unitSearchCtrl: UnitSearchForm
  }
  public setCtrlsData() {
    this.$refs.pointCtrl.setData(this.form.PointList)
  }
  public getCtrlsData() {
    this.form.PointList = this.$refs.pointCtrl.getData()
  }
  public mounted() {
    window.eventBus.$on('submitUnitSearchForm', (data: PopUnitData[]) => {
      this.getUnit(data[0])
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitUnitSearchForm')
  }
  //#region 弹窗查询文保单位
  public openUnitSearch() {
    window.eventBus.$emit('openUnitSearchForm')
  }
  public getUnit(info: PopUnitData) {
    this.form.UnitId = info.UnitId
    this.form.UnitName = info.UnitName
    this.form.UnitCode = info.UnitCode
    this.$refs.formCtrl.validateField('UnitName')
  }
  public closeUnitSearch() {
    console.log("这里是查询文保单位组件关闭后回传的事件")
  }
  public delUnit() {
    this.form.UnitId = 0
    this.form.UnitName = ''
    this.form.UnitCode = ''
    this.$refs.formCtrl.validateField('UnitName')
  }
  public created() {
    this.fetchSource()
    this.fetchData()
  }

  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.categoryList = data.categoryList
      this.brandList = data.brandList
      this.driverList = data.driverList
      this.statusList = data.statusList
    }
  }
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.fetchDevice(id)
  }
  public fetchDevice(id: number) {
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      this.form = response.data
      this.rules = getFormRules(this.form.Id, this.form)
      if (this.form.Id == 0) {
        this.$refs.formCtrl.clearValidate()
      } else {
        this.$nextTick(() => {
          this.setCtrlsData()
        })
      }
      this.loading = false
    })
  }
  public onCancel() {
    this.$router.push({ path: '/UnitDevice' })
  }
  public onSubmit() {
    this.getCtrlsData()
    const promist =
      this.form.Id > 0
        ? putData(this.form.Id, this.form)
        : postData(this.form)
    promist.then((response: { data: any }) => {
      const data = response.data
      const msg = this.form.Id > 0 ? '保存' : '创建'
      if (data && !data.IsError) {
        this.$message({
          message: `${msg}成功`,
          type: 'success'
        })
        this.$router.push({ path: '/UnitDevice' })
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
        })
        console.log(response)
      }
    })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
